import { FC } from 'react';
import WhiteLogo from './assets/logo-mojeo2/MO2white.svg';
import BlueLogo from './assets/logo-mojeo2/MO2blue.svg';
import { styled } from '@mui/material/styles';

export interface MojeO2LogoProps {
  color: 'blue' | 'white';
  width?: string | number;
  height?: string | number;
  maxWidth?: string | number;
  maxHeight?: string | number;
}

const Image = styled('img', {
  name: 'Image',
  slot: 'root',
  shouldForwardProp: (propName) =>
    propName !== 'width' && propName !== 'height' && propName !== 'maxWidth' && propName !== 'maxHeight',
})<Omit<MojeO2LogoProps, 'color'>>(({ theme, width, height, maxWidth, maxHeight }) => ({
  width: width ?? 104,
  height: height ?? 'auto',
  maxWidth: maxWidth ?? '100%',
  maxHeight: maxHeight ?? '100%',
  [theme.breakpoints.down('sm')]: {
    width: width ? undefined : 80,
  },
}));

const LogoMojeO2: FC<MojeO2LogoProps> = ({ color, ...other }) => {
  if (color === 'white') {
    return <Image src={WhiteLogo} alt="Moje O2" {...other} />;
  }

  return <Image src={BlueLogo} alt="Moje O2" {...other} />;
};

export default LogoMojeO2;
